import Slider from './components/Slider';
import functions from './functions';
import inputPopover from "./components/input-popover.js";
import { FormGuide } from "./components/form-guide.js";
import { InputGuests } from "./components/input-guests";
import { DeparturePicker } from "./components/departure-picker.js";
import { Select2 } from "./components/select2";

$(() => {

  if ( ! window.wp?.ajax )
  {
    if(! functions.getCookie('specialModal')) {
      setTimeout(() => {
        $('#specialModal').modal('show');
        functions.setCookie('specialModal', true, 0.1);
      }, 4000);
    }
    
    $('#specialModal').on('shown.bs.modal', e => {
      $('.modal-backdrop.show').css('opacity', '80%');
    });
    $('#specialModal').on('hidden.bs.modal', e => {
      $('.modal-backdrop.show').css('opacity', '50%');
    });
  }

  $('.btn-level').on('click', e => {
    e.preventDefault();
    e.stopPropagation();
    const $target = $(e.currentTarget);
    const $sibling = $target.siblings('.dropdown-submenu');

    $target.toggleClass('show', ! $sibling.hasClass('show'));
    $sibling.toggleClass('show', ! $sibling.hasClass('show'));
  });

  if ($(window).scrollTop() > 10) {
    $('.main-header').addClass('following');
  }

  $(window).scroll(e => {

    $(window).scrollTop() > 10
      ? $('.main-header').addClass('following')
      : $('.main-header').removeClass('following');
  });

  $('#navMainMenu').on('show.bs.collapse', e => {
    $('.navbar').addClass('show');
  });
  $('#navMainMenu').on('hide.bs.collapse', e => {
    $('.navbar').removeClass('show');
  });

  const $heroSlider = $('#hero-slider');

  if ( $heroSlider.length ) {    
      $heroSlider._slider = new Slider($heroSlider, {
        fade: false,
        rubberband: false,
        loop: true,
        arrows: true,
        pager: false,
        //autoplay: 4000,
        slides: {
          perView: 1,
          spacing: 0
        },
        defaultAnimation: {
            duration: 0
        },
        detailsChanged: (s) => {
          s.slides.forEach((element, idx) => {
            if ( s.track.details.slides[idx].portion == 0 ) {
              element.style.opacity = 0;
            }
            if ( s.track.details.slides[idx].portion == 1 ) {
              element.style.opacity = 1;
            }
          })
        },
        //renderMode: "custom",
      });
      $heroSlider.find('.keen-slider__slide').first().addClass('active');
  }

  const isMobile = functions.isMobile();

  let listSlider = [];
  $('[id^=list-slider]').each((i, elem) => {
      const length = $(elem).find('.keen-slider__slide').length;

      listSlider[i] = new Slider('#' + $(elem).attr('id'), {
          rubberband: false,
          loop: true,
          arrows: true,
          spacing: 0,
          pager: false,
          drag: isMobile,
          slides: {
            perView: 3,
            spacing: 0
        },
        breakpoints: {
          '(max-width: 1360px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 3,
                  spacing: 0,
              },
          },
          '(max-width: 991px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 2.2,
                  spacing: 0,
              },
          },
          '(max-width: 767px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 1.1,
                  spacing: 0,
              },
          },
      },
      });

      const $arrows = $(elem).siblings('.keen-slider__arrows');

      if (isMobile && length < 2) {
        $arrows.addClass('d-none');
      } else if (! isMobile && length < 3) {
        $arrows.addClass('d-none');
      } else {
        $arrows.removeClass('d-none');
      }

  });

  let reviewSlider = [];
  $('[id^=review-slider]').each((i, elem) => {
      //const length = $(elem).find('.keen-slider__slide').length;
      reviewSlider[i] = new Slider('#' + $(elem).attr('id'), {
          rubberband: false,
          loop: true,
          arrows: true,
          spacing: 0,
          pager: true,
          //drag: functions.isMobile(),
          drag: true,
          slides: {
            perView: 2,
            spacing: 0
        },
        breakpoints: {
          '(max-width: 1360px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 2,
                  spacing: 0,
              },
          },
          '(max-width: 991px)': {
              origin: 'center',
              drag: true,
              loop: true,
              slides: {
                  perView: 1.2,
                  spacing: 0,
              },
          },
          '(max-width: 767px)': {
              origin: 'center',
              drag: true,
              loop: true,
              arrows: false,
              slides: {
                  perView: 1.1,
                  spacing: 0,
              },
          },
      },
      });
  });

  //let formGuide = [];
  $('.form-guide').each((i, elem) =>{
      elem._formGuide = new FormGuide(elem);
      //formGuide[i + 1] = new FormGuide(elem);
  });

  $('.datepicker.departure-picker:not(#details-datepicker) [data-input]').each((i, elem) => {
    elem._departurePicker = new DeparturePicker(elem);
  });

  $('.input-guests').each((i, elem) => {
    elem._inputGuests = new InputGuests(elem);
  });

  inputPopover.apply();

  $(".select2").each((i, elem) => {
    elem._select2 = new Select2(elem);
  });

  $('[name=dates], [name=dateFrom]').on('change', e => {
    const $target = $(e.currentTarget);
    
    let $datepicker = $target.parents('.datepicker-range');

    if($target.parents('.departure-picker').length) {
      $datepicker = $target.parents('.departure-picker');
    } else if ($target.parents('.datepicker-range-inquiry').length) {
      $datepicker = $target.parents('.datepicker-range-inquiry');
    }

    $datepicker.length && $datepicker.find('[data-clear]').toggleClass('d-none', ! $target.val());
  });

});